// extracted by mini-css-extract-plugin
module.exports = {"productIdentificationNumber":"Brands_productIdentificationNumber__3DWqE"};